import { useField } from "formik"
import React from "react"
import { Checkbox } from "primereact/checkbox"
import { Skeleton } from "primereact/skeleton"
import { InputSwitch } from "primereact/inputswitch"
import CustomTooltip from "../../pages/Kiosk/Admin/Utils/CustomTooltip"

//Style
import styles from "../../styles/Form-Inputs.module.css"
import refStyles from "../../styles/Referrals.module.css"
import kioskStyles from "../../styles/kiosk/KioskAdmin.module.css"

export default function FormikCheckBox(props) {
  const [field, meta, helpers] = useField(props.name)

  const getCheckbox = () => {
    if (props.isInitialLoad) {
      return <Skeleton height="42px" width="42px" />
    } else {
      return (
        <>
          <div className="control">
            {props.useSwitch ? (
              <div
                className={kioskStyles.switchControl}
                style={{ marginLeft: "0px" }}
              >
                <InputSwitch
                  {...field}
                  {...props}
                  checked={field.value}
                  onChange={(e) => {
                    helpers.setValue(e.value)

                    if (props.onChangeCallback) {
                      props.onChangeCallback(e.value)
                    }
                  }}
                  className={`${refStyles.checkBox} ${
                    meta.touched && meta.error ? "p-invalid" : ""
                  }`}
                  disabled={props.disabled}
                />
              </div>
            ) : (
              <Checkbox
                {...field}
                {...props}
                checked={field.value}
                onChange={(e) => {
                  helpers.setValue(e.checked)

                  if (props.onChangeCallback) {
                    props.onChangeCallback(e.checked)
                  }
                }}
                className={`${refStyles.checkBox} ${
                  meta.touched && meta.error !== undefined ? "p-invalid" : ""
                }`}
                disabled={props.disabled}
              />
            )}
            {!!props.checkboxLabel ? (
              <label style={{ marginLeft: "10px" }}>
                {props.checkboxLabel}
              </label>
            ) : null}
          </div>
        </>
      )
    }
  }

  const getLabel = () => {
    if (props.isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <>
          {props.helpIcon && (
            <CustomTooltip
              label={props.helpText}
              position={"right"}
              targetId={props.name}
            />
          )}
          <label>
            {props.label}
            {props.helpIcon && (
              <i
                className={`pi pi-info-circle ${kioskStyles.info}`}
                id={props.name}
              ></i>
            )}
          </label>
        </>
      )
    }
  }

  return (
    <div className={`${styles.field} ${props.className || ""}`}>
      <div className="label">{getLabel()}</div>
      {props.helpText && !props.helpIcon ? (
        <div style={{ marginBottom: "10px" }}>
          <small style={{ color: "gray" }}>{props.helpText}</small>
        </div>
      ) : null}
      {getCheckbox()}
      {meta.touched && meta.error ? (
        <div className="errorLabel">
          <label id={`${props.name}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        </div>
      ) : null}
    </div>
  )
}
